@if(!userInfos && menuTitle){
    <button mat-button [matMenuTriggerFor]="menuName" class="dropdown-toggle header-dropdown" [ngClass]="{'admin-settings-item-menu': (menuTitle == 'header.admin')}">    
        <i class="{{menuIcon}}"></i>
        <span [ngClass]="{'settings-item-menu': (menuTitle == 'header.admin') || (menuTitle == 'header.quickactions')}">
            &nbsp;{{ menuTitle | translate }}&nbsp;
        </span>
        &nbsp;<i class="fa-solid fa-caret-down"></i>
    </button>
}
@if(!userInfos && !menuTitle){
    <button mat-button [matMenuTriggerFor]="menuName" class="dropdown-toggle">
        <i class="{{menuIcon}}"></i>
    </button>
}
@if(userInfos){
    <button mat-button [matMenuTriggerFor]="menuName" class="dropdown-toggle header-dropdown header-user" id="dropdownMenuAccount">
        <username-icon [context]="'menu'"
                       [userInfos]="userInfos"></username-icon>
    </button> 
}
<mat-menu #menuName="matMenu">
    @if(menuItems && menuItems.length > 0){
        <ul class="navbar-nav d-lg-flex align-items-lg-center">
            @for(item of menuItems; track item){
                @switch(item.linkType){
                    @case('link'){
                        <li mat-menu-item>
                            <a class="nav-link p-0 text-dark" [routerLink]="[item.stateName]" title="{{item.name | translate}}">
                                <i class="{{item.icon}}"></i> <strong class="text-dark ps-1">{{item.name | translate}}</strong><br>
                                <em [hidden]="!item.description" class="nav-item-description">{{item.description | translate}}</em>
                            </a>
                        </li>
                    }
                    @case('helplink'){
                        <li mat-menu-item>
                            <a class="nav-link p-0 text-dark menu-help-center" href="{{item.url}}" title="{{item.name | translate}}" target="_blank">
                                <i class="{{item.iconDesc}}"></i>&nbsp;{{item.description | translate}}
                            </a>
                        </li>
                    }
                    @case('text'){
                        @if(userInfos){
                            <li mat-menu-item disabled class="menu-item-text user-account">
                                {{ item.name | translate }} <span class="fw-bold">{{userInfos.firstname}} {{userInfos.lastname}}</span>
                            </li>
                        }@else{
                            <li mat-menu-item disabled class="menu-item-text">
                                @if(item.icon){
                                    <i class="{{item.icon}}"></i>
                                }
                                {{ item.name | translate }}
                            </li>
                        }
                    }
                    @case('separator'){
                        <li mat-menu-item disabled class="dropdown-divider"></li>
                    }
                }
            } 
        </ul>
    } 
</mat-menu>